import { get, post } from "../util/request.js";
export const getContactInfo = () => {
  return get("/website/contact-info");
};
export const coleectMessageRq = (data) => {
  return post("/website/collect-message", data);
};

export const getNewsListRq = (data) => {
  return get("/website/news-list", data);
};
export const getNavListRq = () => {
  return get("/website/nav-list");
};
